import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslocoModule } from "@jsverse/transloco";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { ContainerContentDirective } from "src/app/components/ui/container/directives/container-content.directive";
import { ContainerNoDataContentDirective } from "src/app/components/ui/container/directives/container-no-data-content.directive";
import { ContainerBaseComponent } from "src/app/components/ui/container/container-base/container-base.component";
import { ContainerTabComponent } from "src/app/components/ui/container/container-tab/container-tab.component";
import { SkeletonModule } from "src/app/components/ui/skeleton/skeleton.module";

@NgModule({
  imports: [CommonModule, TranslocoModule, ButtonModule, SkeletonModule],
  declarations: [
    ContainerBaseComponent,
    ContainerContentDirective,
    ContainerNoDataContentDirective,
    ContainerTabComponent
  ],
  exports: [
    ContainerBaseComponent,
    ContainerTabComponent,
    ContainerContentDirective,
    ContainerNoDataContentDirective
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContainerModule {}
